module.exports = __webpack_public_path__ + "img/download-icon-music-select.1338078b.svg";